import styled from 'styled-components';

export const InfoTextWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin-top:0.5rem;
        background-color: #dfecff;
        padding: 1.5rem 2.5rem;
        border-radius: 0.4rem;
    `
);

export const InfoText = styled.p(
    props => `
        font-size:1.4rem;
        color: rgba(0,0,0,0.8);
        line-height: 1.2;
        @media(max-width:1023px){
            font-size:1.2rem;
        }
    `
);

export const LoginPrefix = styled.p(
    props => `
        font-size: 1.6rem;
        color: #000000;
        font-weight: bold;
        padding-left: 0.5rem;
    `
);

export const UserNameHeadText = styled.p(
    props => `
        font-size: 1.2rem;
        color: #000;
        margin-bottom:0.5rem;
        font-weight: bold;
        margin-top:3rem;
    `
);

export const UsernameWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        background-color: #f0f0f0;
        padding: 1.2rem 1rem;
        border-radius: 0.4rem;
        align-items: center;
    `
);

export const LoginNumber = styled.p(
    props => `
        font-size: 1.6rem;
        color: #4a4a4a;
        font-weight: bold;
        padding-left:1rem;
    `
)

export const ResetBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        algin-items: flex-end;
        justify-content: flex-end;
        padding-right:${props.disabled ? '4rem' : '0'};
    `
);

export const ResetOption = styled.a(
    props => `
        font-size: 1.6rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
    `
)

export const TnCtext = styled.p(
    props => `
        font-size: 1.2rem
        color: rgba(0,0,0,0.45);
        text-align: center;
        padding-bottom: 0.5rem;
    `
);

export const EyeWrapper = styled.div(
    props => `
      position: absolute;
      height: 42px;
      right: 0;
      top: 2rem;
      display: flex;
      aling-items: center;
      justidy-content: center;
      border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
    `
);